exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".datePickerMobile__input___20a44::placeholder {\n  color: #828282;\n  font-size: 15px;\n  font-weight: 400;\n  letter-spacing: -0.015em; }\n\n.datePickerMobile__input___20a44 {\n  font-size: 14px;\n  border: none;\n  height: 54px;\n  font-weight: 600; }\n  .datePickerMobile__input___20a44::placeholder {\n    font-size: 14px; }\n", ""]);

// exports
exports.locals = {
	"input": "datePickerMobile__input___20a44"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/DatePickerMobile/datePickerMobile.scss
// module id = 2180
// module chunks = 6